import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

/**
 * FGB Missing translation handler will handle the translation if there is no translation found. To ensure that a translation
 * is always there you will need to added the extra parameter fgbdefault. This is used to replace if there is no translation found.
 * This is a kind of back up
 *
 * @example
 *
 * <p [translate]="'maintenance.text'" [translateParams]="{ fgbdefault : 'The page is currently unavailable'}"></p>
 */
export class FGBMissingTranslationHandler implements MissingTranslationHandler {
  constructor() {}

  /**
   * Handles requests when a translation can not be found
   *
   * @param params missing translation parameter
   */
  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams && params.interpolateParams.hasOwnProperty('fgbdefault')) {
      return (params.interpolateParams as any).fgbdefault;
    }
    return '*' + params.key;
  }
}
